export class CredentialFinding {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialType",
            "baseName": "credentialType",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataLocation",
            "baseName": "dataLocation",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CredentialFinding.attributeTypeMap;
    }
    constructor() {
    }
}
